export default {
    taskTemplate: 'taskTemplateSearch',
    category: 'categorySearch',
    roles: 'rolesSearch',
    firstLevelSearch: 'firstLevelSearch',
    secondLevelSearch: 'secondLevelSearch',
    rota: 'rotaSearch',
    employee: 'employeeSearch',
    completedBy: 'completedBySearch',
    subUnits: 'subUnitsSearch',
    intervals: 'intervalsSearch',
    clinics: 'clinicsSearch',
    assignee: 'assigneeSearch',
    supervisors: 'supervisorsSearch',
    courses: 'coursesSearch',
    templates: 'templatesSearch',
    statuses: 'statuses',
    types: 'types',
    documentPolicies: 'documentPolicies',
    breakdownLogJobTypes: 'breakdownLogJobTypes'
}
